import * as PIXI from "pixi.js";
import SwitcherButton from "../../../../../../src/entities/UI/SwitcherButton/SwitcherButton";
import { BLUE_ANGLE_COLORS, START_BUTTON_STYLE } from "./Config";


const START = SwitcherButton.generateText("Start", 20, BLUE_ANGLE_COLORS[1]);


export default class TestModeModalRenderer extends PIXI.Container {
  private startButton!: SwitcherButton;
  private info = this.addChild(new PIXI.Text());

  constructor(
    private onHandleDownStartFunc: () => void,
  ) {
    super();
    this.addStartButton();
    this.addText();
  }
  private addText() {
    this.info.text = "Let's Start Quiz";
    this.info.anchor.set(.5);
    this.info.x = 0;
    this.info.y = 20;
  }
  private addStartButton() {
    const closeButton = () => setTimeout(() => this.startButton.closeButton(), 200);
    this.startButton = this.addChild(new SwitcherButton(
      START_BUTTON_STYLE,
      START,
      true,
      () => {
        closeButton();
        this.onHandleDownStartFunc()
      },
      () => { }
    ))
  }
}